import { Form, Row, Col, Select, Switch } from "antd";
import { displayMessage } from "../../../utils/common";
import { ERROR_MSG_TYPE } from "../../../constants/messages";
import { ACTIVE_INACTIVE_OPTION } from "../../../constants/constent";

function VendorStatusForm({ vendor, form, onSubmit }) {
  return (
    <Form form={form} layout="vertical">
      <Form.Item name="vendor_id" initialValue={vendor.id} hidden />

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name={`status_${vendor.id}`}
            label="Status"
            initialValue={vendor.status}
          >
            <Select
              options={ACTIVE_INACTIVE_OPTION}
              onChange={(value) => {
                if (value === "active" && !vendor?.document_approved) {
                  displayMessage(
                    ERROR_MSG_TYPE,
                    "Please Approve the Documents first.",
                  );
                  form.setFieldsValue({
                    [`status_${vendor.id}`]: vendor?.status,
                  });
                } else {
                  form.setFieldsValue({
                    [`status_${vendor.id}`]: value,
                  });

                  onSubmit({
                    vendor_id: vendor.id,
                    status: value,
                    is_approved: form.getFieldValue(`is_approved_${vendor.id}`),
                  });
                }
              }}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label="Approved">
            <Switch checked={vendor.is_approved} disabled />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}

export default VendorStatusForm;
